import {
  FpSidebarGroup,
  FpSidebarGroupContent,
  FpSidebarMenu,
  FpSidebarMenuButton,
  FpSidebarMenuItem,
  useFpSidebar,
} from "@/components/ui/fp-sidebar";
import { listProjectsQueryOptions } from "@/lib/hooks/useProjects";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

const inactiveProps = {
  className: "text-muted-foreground",
};

const activeProps = {
  className: "text-foreground bg-secondary",
};

export function RecentItems() {
  const { data } = useQuery(listProjectsQueryOptions());
  const projects = data?.projects ?? [];
  const { setOpenMobile } = useFpSidebar();

  const handleProjectClick = () => {
    // Close sidebar when navigating to a project
    setOpenMobile(false);
  };

  return (
    <FpSidebarGroup className="flex-1 min-h-0">
      <div className="px-4 pb-2">
        <h2 className="text-sm font-medium group-data-[collapsible=icon]:hidden">
          Recent Projects
        </h2>
      </div>
      <FpSidebarGroupContent className="flex-1 overflow-y-auto">
        <FpSidebarMenu className="px-4">
          {projects.map((project) => (
            <FpSidebarMenuItem key={project.id}>
              <FpSidebarMenuButton
                asChild
                className="p-2 text-sm transition-colors hover:bg-muted rounded-xl h-auto justify-start"
              >
                <Link
                  to="/codegen/$projectId"
                  params={{ projectId: project.id }}
                  className="block w-full text-left"
                  activeProps={activeProps}
                  inactiveProps={inactiveProps}
                  onClick={handleProjectClick}
                >
                  <div className="truncate w-full">
                    {project.summary || "New project"}
                  </div>
                </Link>
              </FpSidebarMenuButton>
            </FpSidebarMenuItem>
          ))}
        </FpSidebarMenu>
      </FpSidebarGroupContent>
    </FpSidebarGroup>
  );
}
